<template lang="pug">
.table-item(
  :course-type="course.course_classtype"
  v-bind:class="confirmColor(course.is_expired, course.course_lang, course.course_classtype)"
)
  .item-type
    img.type-img(v-if="course.course_classtype === 'MS' || course.course_classtype === 'CD' || course.course_classtype === 'LP'" src="@/assets/image/m-pic-03.jpg")
    img.type-img(v-else-if="course.course_classtype === 'QT'" src="@/assets/image/m-pic-01.png")
    img.gt-logo(v-else-if="course.course_classtype === 'GT'" src="@/assets/image/g-talk-club.svg")
    img.type-img(v-else src="@/assets/image/course.png")
    .type-text(v-if="course.course_classtype !== 'GT'")
      span(v-for="courseType in $root.total_course", v-if="course.course_classtype === courseType.id") {{ courseType.name }}
  .item-lang(v-if="course.course_classtype === 'GT' && gtLangName(course.course_lang)") {{ gtLangName(course.course_lang) }}
  .item-name {{ course.title }}
  .item-teacher {{ course.coures_teacher.name }}
  .item-time {{ course.start_time }}
  .item-topic(v-if="showGtTopic(course)") {{ course.course_directions }}

  .hide-box(v-if="!last")
    .box-group
      .box-title 課程進度
      .box-text {{ course.course_material }}
    .box-group
      .box-title 課程描述
      .box-text {{ course.course_directions }}
      .box-title 課程教材
      .textbook-text
        img.textbook-img(src="@/assets/image/pdf-icon.png")
        span {{ course.course_material }}
    .box-group.text-align-center(
      v-if="$root.user.id",
      @click="goCourse(course.course_id)"
    )
      .box-button 前往課程

  .hide-box-last(v-if="last")
    .box-group
      .box-title 課程進度
      .box-text {{ course.course_material }}
    .box-group
      .box-title 課程描述
      .box-text {{ course.course_directions }}
    //- .box-group
      .box-title 課程教材
      .textbook-text
        img.textbook-img(src="@/assets/image/pdf-icon.png")
        span {{ course.course_material }}
    .box-group.text-align-center(
      v-if="$root.user.id",
      @click="goCourse(course.course_id)"
    )
      .box-button 前往課程
</template>
<script>
export default {
  name: 'tableItem',
  components: {},
  props: ['course', 'last'],
  data () {
    return {
    };
  },
  methods: {
    //   v-bind:class="course.course_lang === 'en' ? 'item-en' : [course.course_lang === 'ja' ? 'item-jp' : 'item-ko']"

    // GT 主題行：卡片已不顯示課名，直接看課程描述
    showGtTopic (_course) {
      return _course.course_classtype === 'GT' && !!_course.course_directions
    },
    // GT 卡片的語言主標
    gtLangName (_lang) {
      switch (_lang) {
        case 'en': return '美語'
        case 'ja': return '日語'
        case 'ko': return '韓語'
        default: return ''
      }
    },

    // 確認語系對應的顏色
    confirmColor (_isExpired = false, _courseLang = '', _courseType = '') {
      // 當課程已經結束
      if (_isExpired) {
        // return 'bg-gray-1'
      }

      // GT 全球會話班固定使用品牌藍底，不跟語言色
      if (_courseType === 'GT') {
        return 'item-gt course-gt'
      }

      // 根據語言判斷顏色
      let color = ''
      switch (_courseLang) {
        case 'en':
          color = 'item-en'
          break

        case 'ja':
          color = 'item-jp'
          break

        default:
          color = 'item-ko'
          break
      }

      let textcolor = ''
      switch (_courseType) {
        case 'MS':
        case 'CD':
        case 'LP':
          textcolor = 'course-ms'
          break;
        case 'QT':
          textcolor = 'course-qt'
          break;
      }

      return color + ' ' + textcolor
    },
    goCourse (_courseID) {
      this.$root.goPage('/student/course/' + _courseID, 2)
    }
  }
}
</script>

<style lang="sass">
  .bg-gray-1
    background: #D4D4D4

  .course-ms
    .item-type .type-text
      color: #035EF5 !important
    .item-name
      color: #035EF5 !important
    .item-teacher
      color: #035EF5 !important
    .item-time
      color: #035EF5 !important
  .course-qt
    .item-type .type-text
      color: #663399 !important
    .item-name
      color: #663399 !important
    .item-teacher
      color: #663399 !important
    .item-time
      color: #663399 !important
  .course-gt
    //- 立體陰影凸顯 G Talk。這裡是週課表格子，同列會被最高的撐開，
    //- 所以不做 App／後台那種正方形卡片，只加陰影。
    box-shadow: 0 4px 16px 0 rgba(15, 23, 92, .4)
    .item-type img.gt-logo
      width: 5.2rem
      display: block
    .item-topic
      color: #ffffff
      font-weight: 700
      font-size: .8rem
      margin-top: .2rem
    .item-type .type-text
      color: #ffffff !important
    //- 語言主標（美語／日語／韓語）；課名不再顯示（品牌名已在 logo 上）
    .item-lang
      color: #ffffff
      font-weight: 700
      font-size: .95rem
      margin-top: .2rem
    .item-name
      display: none !important
    .item-teacher
      color: #ffffff !important
    .item-time
      color: #ffffff !important
</style>